import { ShadowClass } from "../shadow/shadow";

export class ModalClass {
  constructor(
    triggerButtonsDataAttribute,
    modalId,
    onCloseCallback,
    onOpenCallback
  ) {
    this.triggerButtons = document.querySelectorAll(
      `[data-modal="${triggerButtonsDataAttribute}"]`
    );
    this.modal = document.getElementById(modalId);
    this.close = this.modal.querySelector(".modal__close");
    this.shadowElement = document.querySelector(".shadow_deep");
    this.shadow = new ShadowClass(this.shadowElement);
    this.body = document.querySelector("body");
    this.onCloseCallback = onCloseCallback;
    this.onOpenCallback = onOpenCallback;

    this.init();
  }

  init() {
    this.triggerButtons.forEach((triggerButton) => {
      triggerButton.addEventListener("click", () => {
        this.openModal();
      });
    });

    this.close.addEventListener("click", () => {
      this.closeModal();
    });

    this.shadowElement.addEventListener("click", () => {
      this.closeModal();
    });
  }

  openModal() {
    this.modal.classList.add("modal_visible");
    this.shadow.openShadow();
    this.body.classList.add("no-scroll");

    setTimeout(() => {
      this.modal.classList.add("modal_shown");

      if (this.onOpenCallback) {
        this.onOpenCallback();
      }
    }, 50);
  }

  closeModal() {
    this.modal.classList.remove("modal_shown");
    this.shadow.closeShadow();
    this.body.classList.remove("no-scroll");

    setTimeout(() => {
      this.modal.classList.remove("modal_visible");
      if (this.onCloseCallback) {
        this.onCloseCallback();
      }
    }, 300);
  }
}
